import { render, staticRenderFns } from "./EtagsDialog.vue?vue&type=template&id=530d1e61"
import script from "./EtagsDialog.vue?vue&type=script&lang=js"
export * from "./EtagsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports